import { defaultTo } from "lodash";
import { DateTime } from "luxon";
import { ClinicTaskAssigneeListingModel, IClinicTaskAssigneeListingModel } from "./ClinicTaskAssigneeListingModel";
import { ClinicTaskFollowupListingModel, IClinicTaskFollowupListingModel } from "./ClinicTaskFollowupListingModel";
import { IModel, Model, ModelRecord } from "./Model";
export interface IClinicTaskListingModel extends IModel {
    clinicTaskId: number;
    hospitalId: number;
    clinicTaskTypeId: number;
    clinicTaskType: string;
    clinicTaskStatusId: number;
    clinicTaskStatus: string;
    clientId: number | undefined;
    clientFirstName: string | undefined;
    clientLastName: string | undefined;
    petId: number | undefined;
    petName: string | undefined;
    dateCreated: string;
    dueDate: string;
    closedDate: string | undefined;
    notes: string;
    isUrgent: boolean;
    creatorFirstName: string;
    creatorLastName: string;
    creatorTitle: string;
    assignees: IClinicTaskAssigneeListingModel[];
    followups: IClinicTaskFollowupListingModel[];
    resolvedBy: string | undefined;
}
export class ClinicTaskListingModel extends Model implements ModelRecord<IClinicTaskListingModel> {
    clinicTaskId: number;
    hospitalId: number;
    clinicTaskTypeId: number;
    clinicTaskType: string;
    clinicTaskStatusId: number;
    clinicTaskStatus: string;
    clientId: number | undefined;
    clientFirstName: string | undefined;
    clientLastName: string | undefined;
    petId: number | undefined;
    petName: string | undefined;
    dateCreated: DateTime;
    dueDate: DateTime;
    closedDate: DateTime | undefined;
    notes: string;
    isUrgent: boolean;
    creatorFirstName: string;
    creatorLastName: string;
    creatorTitle: string;
    assignees: ClinicTaskAssigneeListingModel[];
    followups: ClinicTaskFollowupListingModel[];
    resolvedBy: string |undefined;

    constructor(params: Partial<IClinicTaskListingModel>) {
        super(params);
        this.clinicTaskId = defaultTo(params.clinicTaskId, 0);
        this.hospitalId = defaultTo(params.hospitalId, 0);
        this.clinicTaskTypeId = defaultTo(params.clinicTaskTypeId, 0);
        this.clinicTaskType = defaultTo(params.clinicTaskType, "");
        this.clinicTaskStatusId = defaultTo(params.clinicTaskStatusId, 0);
        this.clinicTaskStatus = defaultTo(params.clinicTaskStatus, "");
        this.clientId = defaultTo(params.clientId, undefined);
        this.clientFirstName = defaultTo(params.clientFirstName, undefined);
        this.clientLastName = defaultTo(params.clientLastName, undefined);
        this.petId = defaultTo(params.petId, undefined);
        this.petName = defaultTo(params.petName, undefined);
        this.dateCreated = DateTime.fromISO(defaultTo(params.dateCreated, "2000-01-01"), { zone: "utc" });
        this.dueDate = DateTime.fromISO(defaultTo(params.dueDate, "2000-01-01"), { zone: "utc" });
        this.closedDate = params.closedDate ? DateTime.fromISO(params.closedDate, { zone: "utc" }) : undefined;
        this.notes = defaultTo(params.notes, "");
        this.isUrgent = defaultTo(params.isUrgent, false);
        this.creatorFirstName = defaultTo(params.creatorFirstName, "");
        this.creatorLastName = defaultTo(params.creatorLastName, "");
        this.creatorTitle = defaultTo(params.creatorTitle, "");
        this.assignees = defaultTo(params.assignees, []).map(a => new ClinicTaskAssigneeListingModel(a));
        this.followups = defaultTo(params.followups, []).map(f => new ClinicTaskFollowupListingModel(f));
        this.resolvedBy = defaultTo(params.resolvedBy, undefined);
    }
}
